// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kore-suggestions-container {
  position: absolute;
  bottom: 2px;
  width: 100%;
}
.kore-suggestions-container .suggestion-search-data-parent {
  position: relative;
  bottom: 0px;
  left: 0px;
  right: 0px;
  margin: 0px 5px;
  border: 0;
  padding: 12px 16px;
  max-height: 110px;
  min-height: 110px;
  overflow: auto;
  border-radius: 6px;
  background: #FFFFFF;
  box-shadow: 0px 2px 5px rgba(32, 33, 36, 0.2);
  border-radius: 6px;
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
  z-index: 3;
}
.kore-suggestions-container .suggestion-search-data-parent::before {
  content: "";
  position: absolute;
  width: 16px;
  height: 16px;
  bottom: -9px;
  left: 50%;
  transform: rotate(45deg);
  z-index: -2;
  display: none;
}
.kore-suggestions-container .suggestion-search-data-parent .bottom-to-top-suggestion {
  position: absolute;
  bottom: 6px;
  width: 100%;
  left: -6px;
  overflow: auto;
  max-height: 80px;
}
.kore-suggestions-container .suggestion-search-data-parent .search-suggested-title {
  cursor: pointer;
  width: 100%;
  position: relative;
  padding: 0 13px;
  margin: 5px 0px;
}
.kore-suggestions-container .suggestion-search-data-parent .search-suggested-title:hover .suggestion-list-item {
  background: #EFF0F1;
  box-sizing: border-box;
  border-radius: 5px;
  padding: 6px 7px 6px 30px;
  margin: 0px;
}
.kore-suggestions-container .suggestion-search-data-parent .search-suggested-title.highlightSuggestion .suggestion-list-item {
  background: #EFF0F1;
  box-sizing: border-box;
  border-radius: 5px;
  padding: 6px 7px 6px 30px;
  margin: 0px;
}
.kore-suggestions-container .suggestion-search-data-parent .search-suggested-title .type-select-suggestion {
  position: absolute;
  top: 13px;
  padding: 0px 15px;
  left: 1px;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  max-width: 100%;
  border-radius: 20px;
  border: 0px solid transparent;
  display: inline-block;
}
.kore-suggestions-container .suggestion-search-data-parent .search-suggested-title .suggestion-list-item {
  padding: 6px 10px 6px 30px;
  cursor: pointer;
  box-sizing: border-box;
  display: block;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  max-width: 100%;
  color: #3C4043;
  margin: 0;
  border: 0;
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.kore-suggestions-container .suggestion-search-data-parent .search-suggested-title .suggestion-list-item img {
  position: absolute;
  left: 7px;
  top: 10px;
}
.kore-suggestions-container .suggestion-search-data-parent .title-suggestion {
  font-weight: 600;
  font-size: 12px;
  line-height: 15px;
  text-transform: uppercase;
  color: #9AA0A6;
  margin-bottom: 8px;
}

.kore-typeahead-container {
  width: 100%;
  padding: 2px 0px 2px 0px;
  outline: none;
  display: block;
  font-size: 14px;
  cursor: text;
  margin-bottom: 16px;
  max-height: 70px;
  overflow-x: hidden;
  overflow-y: auto;
  position: absolute;
  top: 0px;
  min-height: 26px;
  z-index: -1;
  color: #8a959f;
}`, "",{"version":3,"sources":["webpack://./src/plugins/searchSuggestions/searchSuggestions.scss"],"names":[],"mappings":"AACA;EACI,kBAAA;EACA,WAAA;EACA,WAAA;AAAJ;AACI;EACI,kBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;EACA,SAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,6CAAA;EACA,kBAAA;EACA,+BAAA;EACA,8BAAA;EACA,UAAA;AACR;AAAQ;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EAEA,YAAA;EACA,SAAA;EACA,wBAAA;EACA,WAAA;EAGA,aAAA;AADZ;AAGQ;EACI,kBAAA;EACA,WAAA;EACA,WAAA;EACA,UAAA;EACA,cAAA;EACA,gBAAA;AADZ;AAGQ;EACI,eAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;AADZ;AAGgB;EACI,mBAAA;EAEA,sBAAA;EACA,kBAAA;EACA,yBAAA;EACA,WAAA;AAFpB;AAMgB;EACI,mBAAA;EAEA,sBAAA;EACA,kBAAA;EACA,yBAAA;EACA,WAAA;AALpB;AAQY;EACI,kBAAA;EACA,SAAA;EACA,iBAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EAEA,mBAAA;EACA,6BAAA;EACA,qBAAA;AAPhB;AASY;EACI,0BAAA;EACA,eAAA;EACA,sBAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;EACA,SAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAPhB;AAQgB;EACI,kBAAA;EACA,SAAA;EACA,SAAA;AANpB;AAUQ;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;AARZ;;AAYA;EACI,WAAA;EACA,wBAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,gBAAA;EACA,WAAA;EACA,cAAA;AATJ","sourcesContent":["\n.kore-suggestions-container{\n    position: absolute;\n    bottom:2px;\n    width: 100%;\n    .suggestion-search-data-parent {\n        position: relative;\n        bottom: 0px;\n        left: 0px;\n        right: 0px;\n        margin: 0px 5px;\n        border: 0;\n        padding: 12px 16px;\n        max-height: 110px;\n        min-height: 110px;\n        overflow: auto;\n        border-radius: 6px;\n        background: #FFFFFF;\n        box-shadow: 0px 2px 5px rgba(32, 33, 36, 0.2);\n        border-radius: 6px;\n        border-bottom-right-radius: 0px;\n        border-bottom-left-radius: 0px;\n        z-index: 3;\n        &::before {\n            content: \"\";\n            position: absolute;\n            width: 16px;\n            height: 16px;\n            // background: var(--sdk-bg-gary-white-color);\n            bottom: -9px;\n            left: 50%;\n            transform: rotate(45deg);\n            z-index: -2;\n            // border-right: 1px solid var(--sdk-border-iron-color);\n            // border-bottom: 1px solid var(--sdk-border-iron-color);\n            display: none;\n        }\n        .bottom-to-top-suggestion{\n            position: absolute;\n            bottom: 6px;\n            width: 100%;\n            left: -6px;\n            overflow: auto;\n            max-height: 80px;\n        }\n        .search-suggested-title {    \n            cursor: pointer;\n            width: 100%;\n            position: relative;\n            padding: 0 13px;\n            margin: 5px 0px;\n            &:hover{\n                .suggestion-list-item{\n                    background: #EFF0F1;\n                    // border: 0px solid var(--sdk-border-malibu-color);\n                    box-sizing: border-box;\n                    border-radius: 5px;\n                    padding: 6px 7px 6px 30px;\n                    margin: 0px;\n                }\n            }\n            &.highlightSuggestion{\n                .suggestion-list-item{\n                    background: #EFF0F1;\n                    // border: 0px solid var(--sdk-border-malibu-color);\n                    box-sizing: border-box;\n                    border-radius: 5px;\n                    padding: 6px 7px 6px 30px;\n                    margin: 0px;\n                }\n            }\n            .type-select-suggestion{\n                position: absolute;\n                top: 13px;\n                padding: 0px 15px;\n                left: 1px;\n                font-weight: normal;\n                font-size: 12px;\n                line-height: 16px;\n                max-width: 100%;\n                // color: var(--sdk-cape-cod-color);\n                border-radius: 20px;\n                border: 0px solid transparent;\n                display: inline-block;\n            }\n            .suggestion-list-item{    \n                padding: 6px 10px 6px 30px;\n                cursor: pointer;\n                box-sizing: border-box;\n                display: block;\n                font-weight: normal;\n                font-size: 14px;\n                line-height: 20px;\n                max-width: 100%;\n                color: #3C4043;\n                margin: 0;\n                border: 0;\n                position: relative;\n                overflow: hidden;\n                text-overflow: ellipsis;\n                white-space: nowrap;\n                img{\n                    position: absolute;\n                    left: 7px;\n                    top: 10px;\n                }\n            }\n        }\n        .title-suggestion{\n            font-weight: 600;\n            font-size: 12px;\n            line-height: 15px;\n            text-transform: uppercase;\n            color: #9AA0A6;\n            margin-bottom: 8px;\n        }\n    }\n}\n.kore-typeahead-container{\n    width: 100%;\n    padding: 2px 0px 2px 0px;\n    outline: none;\n    display: block;\n    font-size: 14px;\n    cursor: text;\n    margin-bottom: 16px;\n    max-height: 70px;\n    overflow-x: hidden;\n    overflow-y: auto;\n    position: absolute;\n    top: 0px;\n    min-height: 26px;\n    z-index: -1;\n    color: #8a959f;\n}\n\n// .kore-chat-footer{\n//     background: transparent;\n// }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
